import React, { useState } from 'react'
 
 
import TransferReceiptList from './TransferReceiptList';
import TransferReceiptFrom from './TransferReceiptFrom';

const TransferReceipt= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");


  return (
    <>
      {fromIsShown ? (
          <TransferReceiptFrom addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <TransferReceiptList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}  
    </>
  )
}

export default TransferReceipt